<fieldset
  class="quick-links-container flex flex-col md:flex-row"
  *ngIf="quickLinks?.length > 0"
  aria-labelledby="quick-links-title"
>
  <div class="flex flex-col md:flex-row">
    <legend class="flex-shrink-0 p-1 ml-2 md:ml-0 mt-2 mb-2">
      <h2
        id="quick-links-title"
        class="dls-body-1-regular whitespace-nowrap"
        *ngIf="title"
        data-cy="quick-links.title"
      >
        {{ 'search_quick_links_title' | translate }}:
      </h2>
    </legend>
    <div
      class="flex flex-wrap items-center"
      [ngClass]="{ 'justify-center': centered }"
    >
      <ng-container
        *ngFor="
          let quickLink of quickLinks;
          trackBy: trackByName;
          let i = index
        "
      >
        <div [attr.data-cy]="'quick-links.link.' + i">
          <div *ngIf="!quickLink.children">
            <zelis-button
              variant="basic"
              (keydown.enter)="onQuickLinkClick(quickLink)"
              (clickFn)="onQuickLinkClick(quickLink)"
            >
              <span
                class="dls-body-2-regular"
                [ngClass]="{
                  'text-palette-m3-system-blue-40': dark
                }"
                >{{ quickLink.name | translate }}</span
              >
            </zelis-button>
          </div>
          <div *ngIf="quickLink.children">
            <zelis-button
              variant="basic"
              [matMenuTriggerFor]="quickLinkMenu"
              (keydown.enter)="onQuickLinkMenuClick(quickLink)"
              (clickFn)="onQuickLinkMenuClick(quickLink)"
            >
              <span
                class="dls-body-2-regular"
                [ngClass]="{
                  'text-palette-m3-system-blue-40': dark
                }"
                >{{ quickLink.name | translate }}</span
              >
              <mat-icon
                svgIcon="dls-caret-down-solid"
                zelisButtonIcon
              ></mat-icon>
            </zelis-button>
            <mat-menu #quickLinkMenu="matMenu">
              <a
                class="quick-links-material-override h-auto"
                *ngFor="
                  let child of quickLink.children;
                  trackBy: trackByName;
                  let j = index
                "
                mat-menu-item
                (keydown.enter)="onQuickLinkClick(child)"
                (click)="onQuickLinkClick(child)"
                [attr.data-cy]="'quick-links.child.' + j"
                (keydown.escape)="handleNavigationKeys(child)"
                (keydown.tab)="handleNavigationKeys(child)"
                (keydown.shift.tab)="handleNavigationKeys(child)"
              >
                <div
                  class="whitespace-normal"
                  [ngClass]="{ 'text-palette-m3-system-blue-40': dark }"
                >
                  {{ child.name | translate }}
                </div>
              </a>
            </mat-menu>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</fieldset>
